import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { VmMachineService } from '../../../services/vm-machine.service';
import { UntypedFormControl, NgForm } from '@angular/forms';
import { Observable, combineLatest, Subject, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ProductService } from '../../product/product.service';
import { Product } from '../../product/product.model';
import { User } from 'src/app/auth/user';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { SystemService } from '../../../services/system.service';
import { ProductEditPopup } from '../../product/product-edit-popup/product-edit-popup';
import { StockingServiceService } from '../../../stocking/stocking-service.service';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { SystemMqttService } from 'src/app/services/system-mqtt.service';

@Component({
  selector: 'app-edit-channel',
  templateUrl: './edit-channel.component.html',
  styleUrls: ['./edit-channel.component.css'],
  encapsulation: ViewEncapsulation.None

})
export class EditChannelComponent implements OnInit, OnDestroy {

  channel;
  channelId;
  inventoryData;
  inventoryDataSub: Subscription;
  value = 2
  myControl = new UntypedFormControl();
  val = new UntypedFormControl();
  products: Product[] = []
  options;
  siteId: string;
  systemId: string;
  machineId: string;
  selectedProductId = "";
  selectedProductImage = "";
  filteredOptions;
  user: User;
  service
  filter$ = new Subject()
  machineType: string;
  obj = {};
  rfidOptions;
  getUnitByCabinetLockerSub: Subscription;
  filterString = ""
  filteredStatesSub: Subscription;
  timer;
  searchResultReceived = false;
  productTypes: { [key: string]: string } = {};
  productTypeKeys: string[] = [];
  hasStockingAccess = false;
  // Test channel button (MQTT). Set false to hide it again.
  showTestChannel = true;
  constructor(private route: ActivatedRoute,
    private vmService: VmMachineService,
    private router: Router,
    private productService: ProductService,
    public auth: AuthService,
    private dialog: MatDialog,
    private systemService: SystemService,
    private stockingService: StockingServiceService,
    private systemMqtt: SystemMqttService,
    private notifierService: NotificationService) {

    this.route.queryParams.subscribe(qp => {
      this.machineType = qp['type'];
    })
    this.route.params.subscribe((params: Params) => {
      this.channel = this.vmService.onChannelSelected(params['channelId'])
        ? this.vmService.onChannelSelected(params['channelId'])
        : this.router.navigate(['../../'], { relativeTo: this.route })
      this.channelId = params['channelId'];
      this.siteId = params['siteId']
      this.systemId = params['systemId']
      this.machineId = params['machineid']

      this.selectedProductImage = ""

      this.inventoryDataSub = this.vmService.onChannelSelectedInventory(params['channelId']).subscribe(data => {
        this.inventoryData = data
      })
      this.productService.getProducts();


    })


  }


  // }

  ngOnInit() {
    this.auth.user$.subscribe(user => {
      this.user = user
      this.hasStockingAccess = !!user && (user['stocking'] == true || this.auth.isSuperAdmin(user))
    })

    this.options = this.productService.data;

    this.filteredOptions = combineLatest([this.options, this.filter$.pipe(startWith(""))]).pipe(map((data: Array<any>) => {
      if (this.filterString != data[1]) {
        this.searchResultReceived = false;
      }
      this.filterString = data[1] as string;

      return ((data[0] as Array<{}>).filter(option => option['searchString'].toLowerCase().includes(data[1]))) ||
        ((data[0] as Array<{}>).filter(option => option['productNumberLowerCase'].toLowerCase().includes(data[1])))
    }))

    this.stockingService.getProductTypesOrdered().subscribe(rows => {
      this.productTypes = {};
      rows.forEach(row => this.productTypes[row.key] = row.category);
      this.productTypeKeys = rows.map(row => row.key);
    })
  }

  // Sent to the machine over MQTT (systems/<number>/actions, type
  // channelVending), as the support service popup sends its commands. The
  // machine reads voltage, extraction time and tray/channel from its own
  // mapping. Its selection counts from 1; channel.selection counts from 0.
  // (Was an HTTP call through henther-api's open request forwarder.)
  // The machine marks a channel sold out on its stock doc; it will not vend
  // from it until sold out is reset, so the test is blocked.
  get isSoldOut(): boolean {
    return this.inventoryData?.status === 'SOLD_OUT';
  }

  async testChannel() {
    if (!this.auth.canPerformActions(this.user)) {
      console.error("user don't have access")
      return;
    }
    if (this.isSoldOut) {
      this.notifierService.showNotification('error', 'This channel is marked sold out, so it cannot be tested.');
      return;
    }
    const systemData: any = await this.systemService.getSystemDetail(this.systemId);
    this.vmService.getMachineDetail().subscribe(async snap => {
      const machine: any = snap.data() || {};
      const payload = {
        name: machine.name,
        index: machine.index,
        selection: Number(this.channel.selection) + 1
      };
      const log = (result: string) => this.systemService.addActionLog(this.siteId, this.systemId, {
        performedBy: this.user.email,
        message: `Test channel vend ${this.channel.selection}`,
        via: 'mqtt',
        type: 'channelVending',
        payload,
        result,
        performedAt: moment().unix()
      });

      if (!machine.name || machine.index === undefined || machine.index === null) {
        this.notifierService.showNotification('error', 'This machine has no name or index set, so it cannot be test vended.');
        return;
      }
      try {
        const result = await this.systemMqtt.sendAction(systemData?.number, 'channelVending', payload);
        if (result === 'offline') {
          this.notifierService.showNotification('error', 'The machine is offline. Nothing was sent.');
          log('machine offline, not sent');
        } else {
          this.notifierService.showNotification('success', `Test vend sent to ${payload.name}${payload.selection}.`);
          log('sent');
        }
      } catch (err) {
        console.error(err);
        this.notifierService.showNotification('error', 'Could not reach the machine: ' + (err?.message || err));
        log('error: ' + (err?.message || err));
      }
    })
  }

  applyFilter(filterValue: string) {
    this.filter$.next(filterValue.toLowerCase());
  }

  onSelectProduct(product) {
    this.selectedProductId = product.id
    this.selectedProductImage = product.imageUrl
  }

  onSubmit(form: NgForm) {
    if (this.auth.canEdit(this.user)) {

      if (this.selectedProductId) {
        this.obj['productId'] = this.selectedProductId;
        this.deAttachProduct(this.channel)
      } else if (this.channel.productId) {
        this.obj['productId'] = this.channel.productId;
      } else {
        this.obj['productId'] = null;
      }

      if (form.value.channelType)
        this.obj['channelType'] = form.value.channelType;

      this.vmService.onUpdateChannel(this.channel.channelId, this.obj)
      this.selectedProductId = null;
    } else {
      this.notifierService.showNotification('warning', "Sorry you don't have sufficient permissions.");
    }
  }

  onSubmit2(form: NgForm) {
    if (this.auth.canEdit(this.user)) {
      if (this.isVendingElement(this.machineType)) {
        this.obj['extractionTime'] = form.value.extractionTime != "" || "undefined" ? form.value.extractionTime : this.channel.extractionTime
        this.obj['voltage'] = form.value.voltage != "" || "undefined" ? form.value.voltage : this.channel.voltage
      }

      if (this.hasStockingAccess && this.productTypeKeys.length)
        this.obj['productType'] = form.value.productType || null;

      // obj.productId = this.selectedProductId ? this.selectedProductId : this.product(this.channel.product).id 
      // if (this.selectedProductId) {

      //   this.obj['productId'] = this.selectedProductId;
      //   this.deAttachProduct(this.channel)
      // }
      // else if (this.channel.productId)
      //   this.obj['productId'] = this.channel.productId;
      // else
      //   this.obj['productId'] = null;

      if (form.value.channelType)
        this.obj['channelType'] = form.value.channelType;

      this.obj['selection'] = this.channel.selection;

      this.vmService.onUpdateChannel(this.channel.channelId, this.obj)
      this.selectedProductId = null;
    } else {
      this.notifierService.showNotification('warning', "Sorry you don't have sufficient permissions.");
    }
  }

  async deAttachProduct(channel) {
    if (this.auth.canEdit(this.user)) {

      this.vmService.deAttachProduct(channel.channelId, channel.productId);
      this.channel.productId = null

    } else {
      this.notifierService.showNotification('warning', "Sorry you don't have sufficient permissions.");
    }
  }

  async inventoryUpdate(inventoryData) {
    this.vmService.updateStockInventory(this.channelId, inventoryData).then(data => {

      this.notifierService.showNotification('success', "Successfully updated!")

    }).catch(err => {
      this.notifierService.showNotification('error', "Some issue happen")

    })

  }

  editProductPopup(pId) {
    this.dialog.open(ProductEditPopup, {
      disableClose: true,
      width: '750px',
      data: {
        pId
      }
    });
  }

  ngOnDestroy() {
    if (this.inventoryData)
      this.inventoryDataSub.unsubscribe();
    if (this.getUnitByCabinetLockerSub)
      this.getUnitByCabinetLockerSub.unsubscribe()
  }

  isVendingElement(machineType) {
    if (machineType == 'vend' || machineType == 'Esplus')
      return true;
    else
      return false;
  }

  checkMaxlimit(inventoryLimit, channelLimit) {
    return inventoryLimit != undefined ? inventoryLimit.maxLimit : channelLimit.maxLimit
  }

}


export class SliderConfigurableExample {
  disabled = false;
  max = 9;
  min = 0;
  showTicks = false;
  step = 1;
  thumbLabel = false;
  value = 0;
}